import React from "react";
import Organistion from "./Resortschema/organisation";
import Breadcrumb from "./Resortschema/breadcrumb";
import LocalBusiness from "./Resortschema/local-business";
import HeatMap from "./Resortschema/heat-map";
import SiteName from "./Resortschema/site-name";
import EducationalPackagesFaq from "./GroupSchema/EducationalPackagesFaq";
import CorporateTourFaq from "./GroupSchema/CorporateTourFaq";
import RestaurantFaq from "./GroupSchema/RestaurantFaq";
import BlogsSchema from "./GroupSchema/BlogsSchema";

const Schema = ({ name }) => {
  return (
    <>
      {name === "Organistion" && <Organistion />}
      {name === "BreadcrumbList" && <Breadcrumb />}
      {name === "LocalBusiness" && <LocalBusiness />}
      {name === "HeatMap" && <HeatMap />}
      {name === "SiteName" && <SiteName />}
      {name === "EducationalPackagesFaq" && <EducationalPackagesFaq />}
      {name === "CorporateTourFaq" && <CorporateTourFaq />}
      {name === "RestaurantFaq" && <RestaurantFaq />}
      {name === "Blogs" && <BlogsSchema />}
    </>
  );
};

export default Schema;
